import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["summaryRow", "detailRow", "detailContent"]

  connect() {
    this.loadedKeys = new Set();

    this.summaryRowTargets.forEach((row) => {
      row.addEventListener("click", () => this.toggleDetail(row));
    });
  }

  async toggleDetail(summaryRow) {
    const schoolId = summaryRow.dataset.schoolId;
    const month    = summaryRow.dataset.month;
    const key      = `${schoolId}-${month}`;

    const detailRow = this.detailRowTargets.find(
      (r) => r.dataset.forSchool === schoolId && r.dataset.forMonth === month
    );
    if (!detailRow) return;

    const isVisible = detailRow.style.display !== "none";

    if (isVisible) {
      detailRow.style.display = "none";
      return;
    }

    detailRow.style.display = "table-row";

    // Already loaded — just show it
    if (this.loadedKeys.has(key)) return;

    const contentEl = detailRow.querySelector("[data-jungle-monthly-breakdown-target='detailContent']");
    if (!contentEl) return;

    try {
      const url = `/admin/jungle/monthly-breakdown/links?school_id=${schoolId}&month=${month}`;
      const response = await fetch(url, {
        headers: { Accept: "text/html", "X-CSRF-Token": this.csrfToken }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      contentEl.innerHTML = html;
      this.loadedKeys.add(key);
    } catch (error) {
      console.error("Error loading link detail:", error);
      contentEl.innerHTML = '<p class="u-textMuted u-textSmall" style="padding: 8px 0;">Could not load payment links.</p>';
    }
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta && meta.content;
  }
}
